var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"WorkOrderList"},[_c('XTable',{attrs:{"api":_vm.getAssistWorkOrder,"state":_vm.workOrderList,"columns":_vm.columns,"loading":_vm.workOrderListLoading,"tableSize":_vm.tableSize,"layout":_vm.layout,"maxHeight":_vm.maxHeight,"firstColumn":_vm.firstColumn}}),_c('WorkOrderDetailModal',{attrs:{"row":_vm.row}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }